import * as React from 'react'
import {useSelector} from 'react-redux'

import detailsSlice from '../detailsSlice'
import {
  selectPushId,
  selectSDKFramework,
  selectSDKFrameworkVersion,
} from '../selectors'
import {useInProductSupportDispatch} from '../store'
import AdditionalTextInput from './AdditionalTextInput'

const IOSAndroidPNSDKAdditionalFields: React.FC = () => {
  const dispatch = useInProductSupportDispatch()

  const pushId = useSelector(selectPushId)
  const sdkFramework = useSelector(selectSDKFramework)
  const sdkFrameworkVersion = useSelector(selectSDKFrameworkVersion)

  const updatePushId = (newPushId: string): void => {
    dispatch(detailsSlice.actions.updateDetails({pushId: newPushId}))
  }

  const updateSDKFramework = (newSDKFramework: string): void => {
    dispatch(
      detailsSlice.actions.updateDetails({sdkFramework: newSDKFramework})
    )
  }

  const updateSDKFrameworkVersion = (newSDKFrameworkVersion: string): void => {
    dispatch(
      detailsSlice.actions.updateDetails({
        sdkFrameworkVersion: newSDKFrameworkVersion,
      })
    )
  }

  return (
    <>
      <AdditionalTextInput
        name="Push ID"
        value={pushId}
        onChange={updatePushId}
        optionalLabel
        helperLink="https://support.airship.com/hc/en-us/articles/213491163-How-to-find-the-Push-ID"
      />
      <AdditionalTextInput
        name="Airship SDK or framework"
        value={sdkFramework}
        onChange={updateSDKFramework}
        optionalLabel
      />
      <AdditionalTextInput
        name="SDK/framework version"
        value={sdkFrameworkVersion}
        onChange={updateSDKFrameworkVersion}
        optionalLabel
      />
    </>
  )
}

export default IOSAndroidPNSDKAdditionalFields
